var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_102",
    "data-name": "Group 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 68,
    height: 68,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M15.544,6a7.3,7.3,0,1,0,7.3,7.3,7.331,7.331,0,0,0-7.3-7.3m0,4.864A2.432,2.432,0,1,1,13.113,13.3a2.4,2.4,0,0,1,2.432-2.432",
    transform: "translate(18.497 13.741)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M34.094,0a2.321,2.321,0,0,0-1.268.331C24.036,5.4,14.588,14.578,14.588,31.614v3.862L.72,49.346A2.43,2.43,0,0,0,2.429,53.5H65.655a2.433,2.433,0,0,0,1.709-4.153L53.5,35.475V31.614C53.5,14.578,44.048,5.4,35.258.331A2.449,2.449,0,0,0,34.107,0ZM34.042,5.37c7.535,4.637,14.591,11.741,14.591,26.244V48.636H19.451V31.614c0-14.5,7.055-21.607,14.591-26.244M14.588,42.343v6.293H8.3Zm38.908,0,6.284,6.293H53.5ZM31.61,60.834v4.786a2.432,2.432,0,1,0,4.864,0V60.834a2.425,2.425,0,0,0-2.458-2.471,2.436,2.436,0,0,0-2.406,2.471m-9.727,0v4.786a2.432,2.432,0,1,0,4.864,0V60.834a2.425,2.425,0,0,0-2.458-2.471,2.436,2.436,0,0,0-2.406,2.471m19.454,0v4.786a2.432,2.432,0,1,0,4.864,0V60.834a2.425,2.425,0,0,0-2.458-2.471,2.436,2.436,0,0,0-2.406,2.471",
    transform: "translate(0 0.287)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon9);
export default __webpack_public_path__ + "static/media/social_icon9.21b4798f991a06275eda342918d316ff.svg";
export { ForwardRef as ReactComponent };